import { SimuladorFinanciamento } from "../../sections/SimuladorFinanciamento/SimuladorFinanciamento";
import type { SimuladorFinanciamentoProps } from "../../sections/SimuladorFinanciamento/types";
import { nextRenderImage } from "../../utils/image/nextRenderImage";
import { useGlobalQueryParams } from "../../hooks/queryParams/useGlobalQueryParams";

/** Wrapper Next.js (renderer): injeta `next/image` na seção framework-agnostic.
    A `dynamicStructure` (modelos + relação de versões + canal) é resolvida
    internamente pela seção via `mapEntries`. */
export const SimuladorFinanciamentoWrapper = (props: SimuladorFinanciamentoProps) => (
  <SimuladorFinanciamento
    {...props}
    renderImage={nextRenderImage}
    useGlobalQueryParams={useGlobalQueryParams}
  />
);

export default SimuladorFinanciamentoWrapper;
